import { gql } from "@apollo/client";

export const CREATE_INVITATION = gql`
  mutation CreateInvitation($input: CreateInvitationInput!) {
    createInvitation(input: $input) {
      mrn
    }
  }
`;
